import { M_REMEMBER_ACC } from './../../models/M_REMEMBER_ACC';
import { BllRememberAcc } from './../../providers/bll/bll-remember-acc';
import { M_USER } from './../../models/M_USER';
import { Ortak } from './../../providers/ortak';
import { M_SERVICE_INFO } from './../../models/M_SERVICE_INFO';
import { BllServisBilgisi } from './../../providers/bll-servis-bilgisi';
import { HomePage } from './../home/home';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, App, MenuController } from 'ionic-angular';
@Component({
  selector: 'page-giris',
  templateUrl: 'giris.html',
})
export class GirisPage {
  Users = [];
  Logins: any;
  sunucuAdresi = "";
  txtkullaniciadi: "";
  txttcno:"";
  txtsifre: any;
  nav: NavController;
  adresler: M_SERVICE_INFO[] = [];
  adres: M_SERVICE_INFO = new M_SERVICE_INFO();
  showServerDropdown: boolean = true;
  girisBilgileriHatirla = false;
  girisSegment = "giris";
  gelenkullanici = [];
  kad: any = {};
  suankitarih;
  kullanicilar: any = { Name: "", Sifre: "" };
  personel: M_USER = new M_USER();
  bllRememberAcc: BllRememberAcc = new BllRememberAcc();
  modelRememberAccounts: M_REMEMBER_ACC[] = [];
  constructor(public navCtrl: NavController,
    public menu: MenuController,
    public ortak: Ortak,
    public bllOrtak: BllOrtak,
    public alert: AlertController,
    public app: App) {
  }

  ionViewDidLoad() {
    this.navCtrl = this.app.getRootNav();
    this.menu.enable(false);
    this.gunkontrol();
    this.ServisAdresGetir();
    this.kullaniciGetir();

  }
  giris(e) {
    if (e.keyCode == 13) {
      this.girisislemi();
    }
  }
  girisislemi() {
    var formData = new FormData();
    formData.append("aranan", this.txtsifre);
    formData.append("kullaniciAdi", this.txtkullaniciadi);
    
    console.log("Giriş işlemi başlatılıyor...");
    console.log("Servis URL:", this.ortak.ServisUrl);
    
    this.bllOrtak.islem(formData, "Login", "", true).then(a => {
      var sonuc = <any>a;
      console.log("Login sonucu:", sonuc);
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    }).catch(error => {
      console.error("Login hatası:", error);
      
      // Hata tipine göre farklı mesajlar göster
      let errorMessage = "Sunucuya bağlanılamıyor. ";
      
      if (error && error.InnerException && error.InnerException.Message) {
        if (error.InnerException.Message.includes("SQL Server")) {
          errorMessage += "Veritabanı sunucusu erişilemiyor. Lütfen sistem yöneticisi ile iletişime geçin.";
        } else if (error.InnerException.Message.includes("timeout")) {
          errorMessage += "Bağlantı zaman aşımına uğradı. Lütfen tekrar deneyin.";
        } else {
          errorMessage += "Ağ bağlantısını kontrol edin.";
        }
      } else {
        errorMessage += "Lütfen internet bağlantınızı kontrol edin.";
      }
      
      this.showAlert("Bağlantı Hatası", errorMessage);
    });
  }
  ureticigiris()
  {
    console.log("Üretici girişi başlatılıyor...");
    console.log("Servis URL:", this.ortak.ServisUrl);
    var formData = new FormData();
    formData.append("tcno", this.txttcno);
  
    this.bllOrtak.islem(formData, "UreticiLogin", "", true).then(a => {
      var sonuc = <any>a;
      console.log("Üretici login sonucu:", sonuc);
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    }).catch(error => {
      console.error("Üretici login hatası:", error);
      
      // Hata tipine göre farklı mesajlar göster
      let errorMessage = "Sunucuya bağlanılamıyor. ";
      
      if (error && error.InnerException && error.InnerException.Message) {
        if (error.InnerException.Message.includes("SQL Server")) {
          errorMessage += "Veritabanı sunucusu erişilemiyor. Lütfen sistem yöneticisi ile iletişime geçin.";
        } else if (error.InnerException.Message.includes("timeout")) {
          errorMessage += "Bağlantı zaman aşımına uğradı. Lütfen tekrar deneyin.";
        } else {
          errorMessage += "Ağ bağlantısını kontrol edin.";
        }
      } else {
        errorMessage += "Lütfen internet bağlantınızı kontrol edin.";
      }
      
      this.showAlert("Bağlantı Hatası", errorMessage);
    });
  }
  ayarKaydet() {
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll().then(b => {
      var sonuc = <any>b;
      if (sonuc.length > 0) {
        var guncellenecekElement = new M_SERVICE_INFO();
        guncellenecekElement.ADRES ="https://tepeli.dnsservis.com"
        guncellenecekElement.ID = sonuc[0].ID;
        bllServisBilgisi.servisBilgisiGuncelle(guncellenecekElement);
        this.ortak.storageServisBilgisiEkle(guncellenecekElement);
        this.ortak.showBasicAlert("Bilgi", "Bağlantı bilgileri güncellendi. Kullanıcı adınız ve şifreniz ile sisteme giriş yapabilirsiniz.");
      }
      else {
        var servis = new M_SERVICE_INFO();
        servis.ADRES = "https://tepeli.dnsservis.com";
        servis.SERVIS_TANIMI = "Sunucu";
        servis.VARSAYILAN = 1;
        bllServisBilgisi.add(servis);
        this.ortak.showBasicAlert("Bilgi", "Yeni servis kaydı yapıldı.");
      }
    });
  }
  showAlert(tittle: string, subTitle: string) {
    let alert = this.alert.create({
      title: tittle,
      subTitle: subTitle,
      buttons: ['Tamam']
    });
    alert.present();
  }
  gunkontrol() {
    console.log("Gün kontrolü başlatılıyor...");
    this.bllOrtak.islemWithoutPost("GununTarihi", "", false).then(a => {
      var sonuc = <any>a;
      console.log("Gün kontrolü sonucu:", sonuc);
      this.suankitarih = this.ortak.tarih(sonuc.SonucObject, "ll");
      this.ortak.storageGunTarihiEkle(sonuc.SonucObject);
    }).catch(error => {
      console.error("Gün kontrolü hatası:", error);
      // Gün kontrolü hatası kritik değil, devam edebiliriz
    });
  }
  ServisAdresGetir() {
    console.log("Servis adresi getiriliyor...");
    var bllServisBilgisi = new BllServisBilgisi();
    bllServisBilgisi.getAll({ ID: 1 }).then(a => {
      var sonuc = <any>a;
      console.log("Servis adresi sonucu:", sonuc);
      if (sonuc && sonuc.length > 0) {
        this.sunucuAdresi = sonuc[0].ADRES;
        console.log("Sunucu adresi:", this.sunucuAdresi);
      }
    }).catch(x => {
      console.error("Servis adresi getirme hatası:", x);
      // Servis adresi yoksa varsayılan değer kullanılacak
    });
  }
  kullaniciGetir() {
    console.log("Kullanıcı bilgileri getiriliyor...");
    var bllRememberAcc = new BllRememberAcc();
    bllRememberAcc.getAll().then(b => {
      var sonuc = <any>b;
      console.log("Kullanıcı bilgileri sonucu:", sonuc);
      if (sonuc && sonuc.length > 0) {
        this.kullanicilar = b[0].Sifre;
        if (this.kullanicilar.length > 1) {
          this.txtkullaniciadi = sonuc[0].Sifre;
          this.txtsifre = sonuc[0].Name;
          this.girisBilgileriHatirla = true;
        }
      }
    }).catch(x => {
      console.error("Kullanıcı bilgileri getirme hatası:", x);
      // Kullanıcı bilgileri yoksa varsayılan değerler kullanılacak
    });
  }
  girisBilgileriniHatirlaIslemleri() {
    this.bllRememberAcc.deleteAll2().then(a => {
      if (this.girisBilgileriHatirla == true) {
        var remAcc = new M_REMEMBER_ACC();
        remAcc.Sifre = this.txtkullaniciadi;
        remAcc.Name = this.txtsifre;
        this.bllRememberAcc.addOrUpdate(remAcc).then(b => {
        })
      }
    })
  }

  // Sunucu bağlantısını test et
  testServerConnection() {
    console.log("Sunucu bağlantısı test ediliyor...");
    console.log("Test URL:", this.ortak.ServisUrl + "TestConnection");
    
    this.bllOrtak.islemWithoutPost("TestConnection", "", false).then(a => {
      console.log("Sunucu bağlantı testi başarılı:", a);
      this.showAlert("Bağlantı Testi", "Sunucuya başarıyla bağlanıldı!");
    }).catch(error => {
      console.error("Sunucu bağlantı testi hatası:", error);
      this.showAlert("Bağlantı Testi", "Sunucuya bağlanılamadı. Lütfen sunucu ayarlarını kontrol edin.");
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/giris/giris.ts